import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconLinkedIn = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={'icon-linkedin' + (className ? ` ${className}` : '')}
            fill={fill}
            height='14'
            viewBox='0 0 14 14'
            width='14'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M10.0381 4.08984C10.1452 4.09615 10.2527 4.10263 10.3535 4.11523C12.099 4.30435 13.0889 5.45124 13.0889 7.39844V13.0889H10.3535V8.00293C10.3535 7.87656 10.3217 6.50985 8.80957 6.50977C8.29912 6.50977 7.84485 6.7367 7.59277 7.19043C7.29695 7.73214 7.3408 8.36203 7.34082 8.9541V13.0508H4.60645V4.3291H7.22168V5.49512C7.22168 5.49512 7.2589 5.43135 7.34082 5.32422C7.64341 4.93343 8.50708 4.02692 10.0381 4.08984ZM2.95508 13.0254H0.219727V4.30371H2.95508V13.0254ZM1.58789 0C2.4649 0 3.17569 0.710907 3.17578 1.58789C3.17578 2.46495 2.46495 3.17578 1.58789 3.17578C0.710906 3.17569 0 2.4649 0 1.58789C9.20506e-05 0.710963 0.710962 9.03763e-05 1.58789 0Z'
                fill={fill}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconLinkedIn;
